import React from 'react';
import Star from '../../images/star.inline.svg';
import * as styles from './Classification.module.scss';
import { clsx } from '../../utils/utils';

interface ClassificationProps {
  ratings: Array<{
    title: string;
    fundRating: 1 | 2 | 3 | 4 | 5;
  }>;
  withSpaceAround?: boolean;
  className?: string;
}

const Classification = ({
  ratings,
  withSpaceAround = false,
  className,
}: ClassificationProps): React.ReactElement => {
  const fundRatingToStarsClass = {
    1: styles.oneStarFill,
    2: styles.twoStarFill,
    3: styles.threeStarFill,
    4: styles.fourStarFill,
    5: styles.fiveStarFill,
  };

  return (
    <div className={clsx(className, withSpaceAround && styles.withSpaceAround)}>
      {ratings.map((rating, i) => (
        <div key={i} className={styles.rating}>
          <span className={styles.ratingTitle}>{rating.title}</span>
          <div className={clsx(styles.starContainer, fundRatingToStarsClass[rating.fundRating])}>
            <Star className={styles.star}></Star>
            <Star className={styles.star}></Star>
            <Star className={styles.star}></Star>
            <Star className={styles.star}></Star>
            <Star className={styles.star}></Star>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Classification;
